import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './payment-detail.html';

@Component({
  controllerAs: 'paymentDetail',
  template
})

export default class paymentDetail {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'toaster',
    '$stateParams',
    'spinnerService',
    'orderService',
    'authService',
    '$window', 'APP',
    'Heartland'
  ];

  constructor($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, Heartland) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    console.log("Calling payment-detail");
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.$toaster = $toaster;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$window = $window;
    this.$auth = $auth;
    this.APP = APP;
    this.$spinner = $spinner;
    this.giftCardNumbers = [];
    this.totalGiftAmount = 0.00;

    this.hasErplyPaymentInitialized=false;
    this.heartand_Approval = "APPROVAL";
    console.log("this.$stateParams.giftcardReq : ", this.$stateParams.giftcardReq);
    this.giftCardsRequest = this.$stateParams.giftcardReq;
    this.storeCreditAmountToBeCharged = this.$stateParams.storeCreditAmountToBeCharged;
    $spinner.show('appSpinner');
    $order.getOrderAmount(this.$stateParams.orderId)
      .then(success => {
        this.orderAmount = success.data;
        $order.getPaymentKeys().then(success => {
          console.log("success -- ", success);
          this.paymentGlobalKey = success.data.globalKey;
          // ----
          this.initializeHeartland(Heartland);
        })
          .finally(() => { 
            this.$order.printPaymentLogs(this.$stateParams.orderId,null," Heartland payment page.").then(success => 
              {
                console.log("Successfully Printed");
              })
            .catch(err => {
                console.log("Failed to print logs");
            });
            $spinner.hide('appSpinner');
          });
      });

    this.$onDestroy = function () {
      this.hps.dispose();
    };
  }

  initializeHeartland(Heartland) {
    var defaultHPS = this.defaultHPS();
    // console.log("defaultHPS: ",defaultHPS);
    if(this.isMobileOnly()){
      defaultHPS.style['#heartland-field[name=submit]']={
          'background-color': '#a4182d',
          'font-family': 'sans-serif',
          'text-transform': 'uppercase',
          'color': '#ffffff',
          'border': '0px solid transparent'
          // 'width': '200px !important',
          // 'margin-left':'5px  !important'
      };
    } else {
      defaultHPS.style['#heartland-field[name=submit]']={
          'background-color': '#a4182d',
          'font-family': 'sans-serif',
          'text-transform': 'uppercase',
          'color': '#ffffff',
          'border': '0px solid transparent',
          'width': '200px !important',
          'margin-left':'5px  !important'
      };
    }
    // console.log("defaultHPS1: ",defaultHPS);
    this.hps = new Heartland.HPS(defaultHPS);

    this.$onDestroy = function () {
      this.hps.dispose();
    };
  }

  clearIframeFields() {
    var heartlandcontenthtml = angular.element(document.querySelector('#heartlandcontent'));
    var iframesG = angular.element(document.querySelector('#iframes'));
    var cardNumberIframe = angular.element(document.querySelector('#iframesCardNumber'));
    var CardExpIframe = angular.element(document.querySelector('#iframesCardExpiration'));
    var CardCvvIframe = angular.element(document.querySelector('#iframesCardCvv'));
    var CardSubmitIframe = angular.element(document.querySelector('#iframesSubmit'));
  }

  goBack() {
    if(this.isGuestProfile()) {
      this.$state.go('guestdelivery');
    } else {
      this.$state.go('delivery');
    }
  }

  mapState(state) {
    return {
      profile: state.auth.profile
    };
  }

  isGuestProfile() {
    if(!this.profile || !this.profile.customer || this.profile.customer.isGuest) {
      return true;
    } else {
      return false;
    }
  }

  round(value){
    return value.toFixed(2);
  }

  getTotalGiftCardAddedAmount() {
    var total = 0.00;
    angular.forEach(this.giftCardsRequest, function (item, key) {
      if (item) {
        total = total + item.amount;
      }
    });
    return total;
  }

  getStoreCreditAmount() {
    var storeCreditAmount = 0.00;
    if(this.storeCreditAmountToBeCharged!=null && this.storeCreditAmountToBeCharged>0){
      storeCreditAmount = this.storeCreditAmountToBeCharged;
    } else {
      storeCreditAmount = 0.00;
    }
    return storeCreditAmount;
  }

  isMobileOnly() {
    // return ( this.$window.innerWidth < 752 && this.$window.innerHeight < 752 );
    return (this.$window.innerWidth < 784);
  }

  isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

  defaultHPS(){
    var $ctrl = this;
    return {
      publicKey: this.paymentGlobalKey,
      type: 'iframe',
      // Configure the iframe fields to tell the library where
      // the iframe should be inserted into the DOM and some
      // basic options
      fields: {
        cardNumber: {
          target: 'iframesCardNumber',
          placeholder: 'xxxx xxxx xxxx xxxx'
        },
        cardExpiration: {
          target: 'iframesCardExpiration',
          placeholder: 'MM / YYYY'
        },
        cardCvv: {
          target: 'iframesCardCvv',
          placeholder: 'CVV'
        },
        submit: {
          value: 'Pay $' + this.round($ctrl.orderAmount-this.getTotalGiftCardAddedAmount()-this.getStoreCreditAmount()),
          target: 'iframesSubmit'
        }
      },
      // Collection of CSS to inject into the iframes.
      // These properties can match the site's styles
      // to create a seamless experience.
      style: {
        'input': {
          'background': '#fff',
          'border': '1px solid',
          'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
          'box-sizing': 'border-box',
          'font-family': 'serif',
          'font-size': '16px',
          'line-height': '1',
          'margin': '0 .5em 0 0',
          'max-width': '100%',
          'outline': '0',
          'padding': '0.5278em',
          'vertical-align': 'baseline',
          'height': '50px',
          'width': '100% !important'
        },
        '#heartland-field': {
          'font-family': 'sans-serif',
          'box-sizing': 'border-box',
          'display': 'block',
          'height': '50px',
          'padding': '6px 12px',
          'font-size': '14px',
          'line-height': '1.42857143',
          'color': '#555',
          'background-color': '#fff',
          'border': '1px solid #ccc',
          'border-radius': '0px',
          '-webkit-box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
          'box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
          '-webkit-transition': 'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
          '-o-transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
          'transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
          'width': '100%'
         
        },
        '#heartland-field[name=submit]': {
          'background-color': '#a4182d',
          'font-family': 'sans-serif',
          'text-transform': 'uppercase',
          'color': '#ffffff',
          'border': '0px solid transparent'
          // 'width': '200px !important',
          // 'margin-left':'5px  !important'
        },
        '#heartland-field[name=submit]:focus': {
          'color': '#ffffff',
          'background-color': '#a4182d',
          'outline': 'none'
        },
        '#heartland-field[name=submit]:hover': {
          'background-color': '#a4182d'
        },
        '#heartland-field-wrapper #heartland-field:focus': {
          'border': '1px solid #3989e3',
          'outline': 'none',
          'box-shadow': 'none',
          'height': '50px'
        },
        'heartland-field-wrapper #heartland-field': {
          'height': '50px'
          
        },
        'input[type=submit]': {
          'box-sizing': 'border-box',
          'display': 'inline-block',
          'padding': '6px 12px',
          'margin-bottom': '0',
          'font-size': '14px',
          'font-weight': '400',
          'line-height': '1.42857143',
          'text-align': 'center',
          'white-space': 'nowrap',
          'vertical-align': 'middle',
          '-ms-touch-action': 'manipulation',
          'touch-action': 'manipulation',
          'cursor': 'pointer',
          '-webkit-user-select': 'none',
          '-moz-user-select': 'none',
          '-ms-user-select': 'none',
          'user-select': 'none',
          'background-image': 'none',
          'border': '1px solid transparent',
          'border-radius': '4px',
          'color': '#fff',
          'background-color': '#a4182d',
          'border-color': '#2e6da4'
          
        },
        '#heartland-field[placeholder]': {
          'letter-spacing': '3px'
        },
        '#heartland-field[name=cardCvv]': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
          'background-size': '63px 40px'
        },
        'input#heartland-field[name=cardNumber]': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
          'background-size': '55px 35px'
        },
        '#heartland-field.invalid.card-type-visa': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
          'background-size': '83px 88px',
          'background-position-y': '-44px'
        },
        '#heartland-field.valid.card-type-visa': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
          'background-size': '82px 86px'
        },
        '#heartland-field.invalid.card-type-discover': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
          'background-size': '85px 90px',
          'background-position-y': '-44px'
        },
        '#heartland-field.valid.card-type-discover': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
          'background-size': '85px 90px',
          'background-position-y': '1px'
        },
        '#heartland-field.invalid.card-type-amex': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
          'background-size': '50px 90px',
          'background-position-y': '-44px'
        },
        '#heartland-field.valid.card-type-amex': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
          'background-size': '50px 90px'
        },
        '#heartland-field.invalid.card-type-mastercard': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
          'background-size': '62px 105px',
          'background-position-y': '-52px'
        },
        '#heartland-field.valid.card-type-mastercard': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
          'background-size': '62px 105px',
          'background-position-y': '-1px'
        },
        '#heartland-field.invalid.card-type-jcb': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
          'background-size': '55px 94px',
          'background-position-y': '-44px'
        },
        '#heartland-field.valid.card-type-jcb': {
          'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
          'background-size': '55px 94px',
          'background-position-y': '2px'
        },
        'input#heartland-field[name=cardNumber]::-ms-clear': {
          'display': 'none'
        }
      },
      // Callback when a token is received from the service
      onTokenSuccess: function (resp) {
        console.log("Token Success", resp.token_value);
        $ctrl.$spinner.show('appSpinner');
        let dataReq = {
          "token": resp.token_value,
          "orderId": $ctrl.$stateParams.orderId,
          // "isNewCard": true,
          "cardLast4": resp.last_four,
          "cardType": resp.card_type,
          "cardNumber": resp.card.number,
          "expiryMonth": resp.exp_month,
          "expiryYear": resp.exp_year,
          "getGiftCardPreAuthRequest": {
            "getGiftCardPreAuthCardRequestList": $ctrl.giftCardsRequest
          },
          "storeCreditAmountToBeCharged": $ctrl.storeCreditAmountToBeCharged
        };

        if(!$ctrl.hasErplyPaymentInitialized){
          $ctrl.hasErplyPaymentInitialized=true;
              $ctrl.$order.initializePaymentHeartland(dataReq)
                .then(success => {
                  $ctrl.hasErplyPaymentInitialized=false;
                  $ctrl.$spinner.hide('appSpinner');
                  $ctrl.showHeartLandPage = false;
                  if (success.data.successCode === '00' && success.data.message === $ctrl.heartand_Approval) {
                    $ctrl.$state.go('payment.success', {
                      orderId: $ctrl.$stateParams.orderId,
                      isCardSaved: true
                    });
                  }
                  else {
                    $ctrl.$state.go('payment.failure', {
                      orderId: $ctrl.$stateParams.orderId,
                      logString: JSON.stringify(success)+" - Heartland payment failed.",
                      reasonCode: success.data.successCode
                    });
                  }
                },
                  error => {
                    $ctrl.hasErplyPaymentInitialized=false;
                    $ctrl.showHeartLandPage = false;
                    $ctrl.$spinner.hide('appSpinner');
                    $ctrl.$state.go('payment.failure', {
                      orderId: $ctrl.$stateParams.orderId,
                      logString: JSON.stringify(error)+" - Heartland payment failed with some error."
                    });
                  }
                )
                .catch(err => {
                  $ctrl.hasErplyPaymentInitialized=false;
                  $ctrl.showHeartLandPage = false;
                  console.log("Api call failure -  ", err);
                  $ctrl.$spinner.hide('appSpinner');
                  $ctrl.$state.go('payment.failure', {
                    orderId: $ctrl.$stateParams.orderId,
                    logString: JSON.stringify(err)+" - Heartland payment failed error printed in catch."
                  });
                });
        }
      },
      // Callback when an error is received from the service
      onTokenError: function (resp) {
        $ctrl.hasErplyPaymentInitialized=false;
        $ctrl.showHeartLandPage = false;
        console.log("Token Failed, card details might be wrong");
        // $ctrl.$state.go('payment.failure', {
        //   orderId: $ctrl.$stateParams.orderId
        // });
      },
      // Callback when an event is fired within an iFrame
      onEvent: function (ev) {
        // console.log(ev);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/order/payment/payment-detail.js